<script lang="ts">
    export let value: any
    export let style = ""
</script>

<span style="{style}">
    {@html value == undefined || value == null ? "" : value}
</span>
